<template>
  <v-container>
    <v-card :class="{'elevation-2': $vuetify.breakpoint.smAndUp, 'elevation-0 rounded-0': $vuetify.breakpoint.xsOnly}">
      <v-form ref="form" lazy-validation
              :class="{'mb-8 py-10': $vuetify.breakpoint.smAndUp, 'mb-8 pt-10 pb-6': $vuetify.breakpoint.xsOnly}">
        <v-row justify="center">
          <v-col cols="11" class="pt-0">
            <h2 class="pb-5" v-if="!$vuetify.breakpoint.smAndDown">Notification Setup</h2>
            <h2 style="font-size: 20px;" v-else>Notification Setup</h2>
            <br/>
            <v-text-field class="pb-0 mb-0"
                          v-model="name"
                          @keydown.enter.prevent
                          label="Notification Name"
                          placeholder=" "
                          outlined
                          :rules="[v => !!v || 'Please enter a notification name']"
                          required/>
            <p>This is your internal reference and will not be seen by the audience.</p>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="11">
            <h3 :class="{'pb-1': $vuetify.breakpoint.smAndDown, 'pb-5': $vuetify.breakpoint.mdAndUp}">Delivery
              Method</h3>
            <v-row>
              <v-col cols="12">
                <v-radio-group v-model="deliveryMethod" row class="mt-0">
                  <v-radio v-for="option in deliveryMethodOptions"
                           :key="option.code"
                           :label="option.label"
                           :value="option.code"
                           :class="'radioButton radioButtonMethod radio' + option.code"
                           color="primary"
                  >
                    <template v-slot:label>
                  <span class="d-flex align-center">
                    <v-icon
                      large
                      class="pl-1 pr-1"
                      color="primary"
                    >
                      {{ option.icon }}
                    </v-icon>
                    <span class="mb-0 ml-2">{{ option.label }}</span>
                  </span>
                    </template>
                  </v-radio>
                </v-radio-group>
                <div v-if="deliveryMethod === 'inbox'">
                  <v-checkbox v-model="sendPushNotification" id="checkboxPush">
                    <template v-slot:label>
                      <p class="mb-0 ml-2" id="checkboxLabel">Send <strong>Push notification</strong> through Staff Portal App as well.</p>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-row :class="{'px-3': $vuetify.breakpoint.xsOnly}">
      <v-col lg="12"
             :class="{'pt-0 d-flex justify-space-between': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
        <AdsButton
          icon="delete"
          button-text="Discard"
          :id="$vuetify.breakpoint.xs ? 'discardButton' : null"
          secondary
          :class="{'mt-3': $vuetify.breakpoint.xsOnly}"
          @click="showDeleteDialog"
          v-if="$store.getters.currentNotification"
        />
        <v-spacer v-else/>
        <div
          :class="{'pt-0 d-flex justify-end': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
          <AdsButton
            :loading="loadingSaveAndClose"
            button-text="Save & Close"
            tertiary
            @click="setupSubmit('close')"
            :disabled="!isValid"
            :class="{'mr-3': $vuetify.breakpoint.smAndUp, 'mt-3': $vuetify.breakpoint.xsOnly}"
            style="height: 52px;"
          />
          <AdsButton
            :loading="loadingSaveAndContinue"
            button-text="Save & Continue"
            @click="setupSubmit('continue')"
            :disabled="!isValid"
          />
        </div>
      </v-col>
    </v-row>
    <DiscardDialog v-model="deleteDialog" :delete-item="deleteItem" :show-delete-dialog="showDeleteDialog"/>
  </v-container>
</template>

<script>
import {DELIVERY_METHOD} from '@/static/data';
import {AdsButton} from '@nswdoe/doe-ui-core';
import DiscardDialog from "@/components/DiscardDialog";

export default {
  name: 'notificationStepOne',
  components: {
    AdsButton,
    DiscardDialog
  },
  data() {
    return {
      name: null,
      deliveryMethodOptions: DELIVERY_METHOD,
      deliveryMethod: "inbox",
      deleteDialog: false,
      loadingSaveAndClose: false,
      loadingSaveAndContinue: false,
      sendPushNotification: false
    }
  },
  computed: {
    isValid() {
      return this.name;
    },
    method() {
      if (this.deliveryMethod === 'inbox' && this.sendPushNotification) {
        return 'syssend';
      } else {
        return 'websend';
      }
    },
    displayMethod() {
      return this.deliveryMethod === 'inbox' ? "" : "portal_banner";
    }
  },
  methods: {
    setupSubmit(next) {
      if (next === 'close') {
        this.loadingSaveAndClose = true;
      }
      if (next === 'continue') {
        this.loadingSaveAndContinue = true;
      }
      if (this.isValid) {
        const formData = {
          name: this.name,
          method: this.method,
          displayMethod: this.displayMethod
        };
        //setting notification setup details
        this.$store.commit('setNotificationSetupDetails', formData);
        if (!this.$store.getters.currentNotification) {
          this.$store.dispatch('createNotification')
            .then(() => {
              if (next === 'close') {
                this.$store.commit('setAlert', 'draft');
                this.$emit('close');
              } else {
                this.$emit('progress');
              }
            })
            .catch(err => {
              this.$store.commit('setCreateMode', false);
              if (next === 'close') {
                this.$store.commit('setAlert', 'createError');
                this.$store.commit('setShowAlert', true);
                setTimeout(() => {
                  this.$store.commit('setShowAlert', false);
                  this.$store.commit('setAlert', '');
                }, 2000);
                this.$router.push({name: 'notifications'});
              } else {
                if (err.response && err.response.data.errMsg) {
                  err = `<p>${err}</p>
                   <p>Description: ${err.response.data.errMsg}</p>`
                } else {
                  err = `<p>${err}.</p>`
                }
                this.$store.commit('setErrorMessage', err);
                this.$router.push({name: 'error'});
              }
            })
            .finally(() => {
              if (next === 'close') {
                this.loadingSaveAndClose = false;
              }
              if (next === 'continue') {
                this.loadingSaveAndContinue = false;
              }
            });
        } else {
          this.$store.commit('setNotificationInfo', {status: 'Draft'});
          let draftPage = 1;
          if (this.$store.getters.currentNotification.draftPage > 1) {
            draftPage = this.$store.getters.currentNotification.draftPage;
          }
          this.$store.dispatch('updateNotification', draftPage)
            .then(() => {
              if (next === 'close') {
                this.$store.commit('setAlert', 'draft');
                this.$emit('close');
              } else {
                this.$emit('progress');
              }
            })
            .catch(err => {
              if (next === 'close') {
                this.$store.commit('setAlert', 'draftError');
                this.$router.push({name: 'notifications'});
                setTimeout(() => {
                  this.$store.commit('setShowAlert', false);
                  this.$store.commit('setAlert', '');
                }, 2000);
              } else {
                if (err.response && err.response.data.errMsg) {
                  err = `<p>${err}</p>
                   <p>Description: ${err.response.data.errMsg}</p>`
                } else {
                  err = `<p>${err}.</p>`
                }
                this.$store.commit('setErrorMessage', err);
                this.$router.push({name: 'error'});
              }
            })
            .finally(() => {
              if (next === 'close') {
                this.loadingSaveAndClose = false;
              }
              if (next === 'continue') {
                this.loadingSaveAndContinue = false;
              }
            })
        }
      }
    },
    showDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    deleteItem() {
      this.$store.dispatch("deleteNotification", this.$store.getters.currentNotification.draftId)
        .finally(() => {
          this.deleteDialog = false;
          this.$store.commit('setCreateMode', false);
          this.$router.push({name: "notifications"});
        });
    },
  },
  created() {
    if (this.$store.getters.currentNotification) {
      this.name = this.$store.getters.notificationSetupDetails.name;
      this.deliveryMethod = this.$store.getters.notificationSetupDetails.displayMethod === "portal_banner" ? "portal_banner" : 'inbox';
      if (this.$store.getters.notificationSetupDetails.method === 'syssend') {
        this.sendPushNotification = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input--radio-group--row .v-input--radio-group__input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#checkboxLabel {
  color: #121212;
}

.v-item--active {
  border: 2px solid #041E42 !important;
  background-color: #DADADA;
}

.radioButton {
  border: 1px solid #6D7079;
  border-radius: 4px;
  padding: 20px;
  height: 100px;
  margin-top: 24px;
  margin-right: 0 !important;
}

.radioButtonMethod {
  min-width: calc(100% / 2 - 12px);
}

@media only screen and (max-width: 780px) {
  .radioButtonMethod {
    min-width: 100%;
  }
}
</style>
